import { render, staticRenderFns } from "./fhOfficialAccount.vue?vue&type=template&id=dccdd0c4"
var script = {}
import style0 from "./fhOfficialAccount.vue?vue&type=style&index=0&id=dccdd0c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports